import { Component, Input } from '@angular/core';
import { ToastMessageOptions } from 'primeng/api';
import { MessageModule } from 'primeng/message';

type MessageSeverity = 'success' | 'info' | 'warn' | 'error' | 'secondary' | 'contrast';

@Component({
  selector: 'p-messages',
  imports: [MessageModule],
  template: `<div class="flex flex-col gap-[var(--p-message-content-gap)]">
    @for (message of value; track $index) {
      <p-message [severity]="getSeverity(message.severity)" [icon]="getIconClass(message.severity)" closable>
        {{ message.detail }}
      </p-message>
    }
  </div>`,
})
export class PMessagesComponent {
  @Input()
  value: ToastMessageOptions[] = [];

  private static icons: Record<string, string> = {
    success: 'pi-check',
    info: 'pi-info-circle',
    warning: 'pi-exclamation-triangle',
    error: 'pi-times-circle',
  };

  private static severityMap: Record<string, MessageSeverity> = {
    success: 'success',
    info: 'info',
    warn: 'warn',
    warning: 'warn',
    error: 'error',
    secondary: 'secondary',
    contrast: 'contrast',
  };

  getSeverity(severity?: string | null): MessageSeverity | undefined {
    if (severity == null) {
      return undefined;
    }

    return PMessagesComponent.severityMap[severity] ?? 'info';
  }

  getIconClass(severity?: string | null) {
    const key = severity === 'warn' ? 'warning' : (severity ?? 'info');
    const icon = PMessagesComponent.icons[key] ?? PMessagesComponent.icons['info'];
    return `pi ${icon}`;
  }
}
